// import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
// import MobileMenu from '../../components/MobileMenu'
// // import { totalPrice } from "../../utils";
// import { connect } from "react-redux";
// import { removeFromCart } from "../../store/actions/action";
// import MeetingScheduler from '../MeetingScheduler';
// import Logo from '../../images/logo/maak-dream-logo.png'


// const Header = (props) => {

//     // const [menuActive, setMenuState] = useState(false);
//     // const [cartActive, setcartState] = useState(false);
//     const [meetingSchedulerOpen, setMeetingSchedulerOpen] = useState(false);
//     // const SubmitHandler = (e) => {
//     //     e.preventDefault()
//     // }

//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }

//     // const { carts } = props;

//     return (
//         <>
//             <header id="header">
//                 <div className={`wpo-site-header ${props.hclass}`}>
//                     <nav className="navigation navbar navbar-expand-lg navbar-light">
//                         <div className="container-fluid">
//                             <div className="row align-items-center">
//                                 <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
//                                     <div className="mobail-menu">
//                                         <MobileMenu />
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-3 col-md-6 col-6">
//                                     <div className="navbar-header">
//                                         <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={Logo}
//                                             alt="" /></Link>
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-6 col-md-1 col-1">
//                                     <div id="navbar" className="collapse navbar-collapse navigation-holder">
//                                         <button className="menu-close"><i className="ti-close"></i></button>
//                                         <ul className="nav navbar-nav mb-2 mb-lg-0">
//                                             <li className="menu-item-has-children">
//                                                 <Link onClick={ClickHandler} to="/">Home</Link>
//                                                 {/* <ul className="sub-menu">
//                                                 <li><Link onClick={ClickHandler} to="/home">Home Style 1</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/home2">Home Style 2</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/home3">Home Style 3</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/home4">Home Style 4</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/home5">Home Style 5</Link></li>
//                                             </ul> */}
//                                             </li>
//                                             <li><Link onClick={ClickHandler} to="/about">About</Link></li>

//                                             {/* <li className="menu-item-has-children"> */}
//                                             {/* <Link to="/service">Service</Link> */}
//                                             {/* <ul className="sub-menu">
//                                                 <li><Link onClick={ClickHandler} to="/service">Service</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/service-s2">Service S2</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/service-single/1">Service Single</Link></li>
//                                             </ul> */}
//                                             {/* </li> */}

//                                             {/* <li className="menu-item-has-children">
//                                             <Link to="/service">Service</Link>
//                                             <ul className="sub-menu">
//                                                 <li><Link onClick={ClickHandler} to="/service">Service</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/service-s2">Service S2</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/service-single/1">Service Single</Link></li>
//                                             </ul>
//                                         </li> */}

//                                             <li className="menu-item-has-children">
//                                                 <Link onClick={ClickHandler} to="/project">Project</Link>
//                                             </li>
//                                             <li className="menu-item-has-children">
//                                             <Link onClick={ClickHandler} to="/blog">Blog</Link>
//                                             {/* <ul className="sub-menu">
//                                                 <li><Link onClick={ClickHandler} to="/blog">Blog right sidebar</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/blog-left-sidebar">Blog left sidebar</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/blog-fullwidth">Blog fullwidth</Link></li>
//                                                 <li className="menu-item-has-children">
//                                                     <Link onClick={ClickHandler} to="/">Blog details</Link>
//                                                     <ul className="sub-menu">
//                                                         <li><Link onClick={ClickHandler} to="/blog-single/1">Blog details right sidebar</Link>
//                                                         </li>
//                                                         <li><Link onClick={ClickHandler} to="/blog-left-sidebar/1">Blog details left
//                                                             sidebar</Link></li>
//                                                         <li><Link onClick={ClickHandler} to="/blog-single-fullwidth/1">Blog details
//                                                             fullwidth</Link></li>
//                                                     </ul>
//                                                 </li>
//                                             </ul> */}
//                                         </li>
//                                             <li><Link onClick={ClickHandler} to="/broker-registration">Broker Registration</Link></li>
//                                             {/* <li className="menu-item-has-children">
//                                             <Link to="/">Pages</Link>
//                                             <ul className="sub-menu">
//                                                 <li><Link onClick={ClickHandler} to="/shop">Shop</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/product-single/1">Shop Single</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/cart">Cart</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/checkout">Checkout</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/pricing">Pricing</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/team-single/1">Team Single</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/testimonial">Testimonial</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/404">404 Error</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/login">Login</Link></li>
//                                                 <li><Link onClick={ClickHandler} to="/register">Register</Link></li>
//                                             </ul>
//                                         </li> */}
//                                             <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                                 <div className="col-lg-3 col-md-2 col-2">
//                                     <div className="header-right">
//                                         <div className="header-search-form-wrapper">
//                                             <div className="cart-search-contact">
//                                                 <div className="header-buttons" style={{
//                                                     display: 'flex',
//                                                     gap: '12px',
//                                                     alignItems: 'center'
//                                                 }}>
//                                                     {/* Login Button - Hidden on mobile */}
//                                                     <Link
//                                                         to="/login"
//                                                         onClick={ClickHandler}
//                                                         className="login-btn d-none d-lg-block"
//                                                         style={{
//                                                             background: '#336699',
//                                                             border: 'none',
//                                                             borderRadius: '25px',
//                                                             padding: '10px 20px',
//                                                             color: 'white',
//                                                             fontSize: '14px',
//                                                             fontWeight: '600',
//                                                             cursor: 'pointer',
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             gap: '8px',
//                                                             transition: 'all 0.3s ease',
//                                                             textDecoration: 'none',
//                                                             position: 'relative',
//                                                             // boxShadow: '0 4px 12px rgba(202, 171, 3, 0.3)'
//                                                         }}
//                                                         onMouseOver={(e) => {
//                                                             e.target.style.transform = 'translateY(-2px)';
//                                                             // e.target.style.boxShadow = '0 6px 20px rgba(202, 171, 3, 0.5)';
//                                                         }}
//                                                         onMouseOut={(e) => {
//                                                             e.target.style.transform = 'translateY(0)';
//                                                             // e.target.style.boxShadow = '0 4px 12px rgba(202, 171, 3, 0.3)';
//                                                         }}
//                                                     >
//                                                         {/* CRM Badge */}
//                                                         <div
//                                                             style={{
//                                                                 position: 'absolute',
//                                                                 top: '-6px',
//                                                                 right: '-12px',
//                                                                 background: '#ff6b35',
//                                                                 color: 'white',
//                                                                 fontSize: '10px',
//                                                                 fontWeight: 'bold',
//                                                                 padding: '2px 6px',
//                                                                 borderRadius: '10px',
//                                                                 boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
//                                                                 zIndex: 1,
//                                                                 minWidth: '24px',
//                                                                 textAlign: 'center'
//                                                             }}
//                                                         >
//                                                             CRM
//                                                         </div>
//                                                         <i className="ti ti-user" style={{ fontSize: '16px' }}></i>
//                                                         <span> Login</span>
//                                                     </Link>

//                                                     {/* Schedule Meeting Button */}
//                                                     <button
//                                                         onClick={() => setMeetingSchedulerOpen(true)}
//                                                         className="schedule-meeting-btn"
//                                                         style={{
//                                                             background: '#336699',
//                                                             border: 'none',
//                                                             borderRadius: '25px',
//                                                             padding: '10px 10px',
//                                                             color: 'white',
//                                                             fontSize: '14px',
//                                                             fontWeight: '600',
//                                                             cursor: 'pointer',
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             gap: '8px',
//                                                             transition: 'all 0.3s ease',
//                                                             textDecoration: 'none'
//                                                         }}
//                                                         onMouseOver={(e) => {
//                                                             e.target.style.transform = 'translateY(-2px)';
//                                                         }}
//                                                         onMouseOut={(e) => {
//                                                             e.target.style.transform = 'translateY(0)';
//                                                         }}
//                                                     >
//                                                         <i className="fi ti-calendar" style={{ fontSize: '16px', color: 'white' }}></i>
//                                                         <span>Schedule Meeting</span>
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         {/* <div className="mini-cart">
//                                         <button className="cart-toggle-btn" onClick={() => setcartState(!cartActive)}>
//                                             {" "}
//                                             <i className="fi ti-shopping-cart"></i>{" "}
//                                             <span className="cart-count">{carts.length}</span>
//                                         </button>
//                                         <div className={`mini-cart-content ${cartActive ? "mini-cart-content-toggle" : ""}`}>
//                                             <button className="mini-cart-close" onClick={() => setcartState(!cartActive)}><i className="ti-close"></i></button>
//                                             <div className="mini-cart-items">
//                                                 {carts &&
//                                                     carts.length > 0 &&
//                                                     carts.map((catItem, crt) => (
//                                                         <div className="mini-cart-item clearfix" key={crt}>
//                                                             <div className="mini-cart-item-image">
//                                                                 <span>
//                                                                     <img src={catItem.proImg} alt="icon" />
//                                                                 </span>
//                                                             </div>
//                                                             <div className="mini-cart-item-des">
//                                                                 <p>{catItem.title} </p>
//                                                                 <span className="mini-cart-item-price">
//                                                                     ${catItem.price} x {" "} {catItem.qty}
//                                                                 </span>
//                                                                 <span className="mini-cart-item-quantity">
//                                                                     <button
//                                                                         onClick={() =>
//                                                                             props.removeFromCart(catItem.id)
//                                                                         }
//                                                                         className="btn btn-sm btn-danger"
//                                                                     >
//                                                                         <i className="ti-close"></i>
//                                                                     </button>{" "}
//                                                                 </span>
//                                                             </div>
//                                                         </div>
//                                                     ))}
//                                             </div>
//                                             <div className="mini-cart-action clearfix">
//                                                 <span className="mini-checkout-price">Subtotal: <span> ${totalPrice(carts)}</span></span>
//                                                 <div className="mini-btn">
//                                                     <Link to="/checkout" className="view-cart-btn s1">Checkout</Link>
//                                                     <Link to="/cart" className="view-cart-btn">View Cart</Link>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div> */}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </nav>
//                 </div>
//             </header>

//             {/* Meeting Scheduler Modal */}
//             <MeetingScheduler
//                 isOpen={meetingSchedulerOpen}
//                 onClose={() => setMeetingSchedulerOpen(false)}
//             />
//         </>
//     )
// }

// const mapStateToProps = (state) => {
//     return {
//         carts: state.cartList.cart,
//     };
// };
// export default connect(mapStateToProps, { removeFromCart })(Header);
















import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from '../../components/MobileMenu';
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import MeetingScheduler from '../MeetingScheduler';
import { getHeader } from '../../api/Home'; // your dynamic API
import LogoFallback from '../../images/logo/maak-dream-logo.png'; // fallback logo

const Header = (props) => {
    const [headerData, setHeaderData] = useState(null);
    const [meetingSchedulerOpen, setMeetingSchedulerOpen] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    useEffect(() => {
        const fetchHeader = async () => {
            try {
                const data = await getHeader();
                setHeaderData(data);
            } catch (error) {
                console.error("Error fetching header data:", error);
            }
        }
        fetchHeader();
    }, []);

    return (
        <>
            <header id="header">
                <div className={`wpo-site-header ${props.hclass}`}>
                    <nav className="navigation navbar navbar-expand-lg navbar-light">
                        <div className="container-fluid">
                            <div className="row align-items-center">
                                <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                    <div className="mobail-menu">
                                        <MobileMenu />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6">
                                    <div className="navbar-header">
                                        <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                            <img src={headerData?.logo || LogoFallback} alt="Logo" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-1 col-1">
                                    <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                        <button className="menu-close"><i className="ti-close"></i></button>
                                        <ul className="nav navbar-nav mb-2 mb-lg-0">
                                            <li className="menu-item-has-children">
                                                <Link onClick={ClickHandler} to={headerData?.button_one_link || "/"}>{headerData?.first_button || "Home"}</Link>
                                            </li>
                                            <li>
                                                <Link onClick={ClickHandler} to={headerData?.button_two_link || "/about"}>{headerData?.second_button || "About"}</Link>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <Link onClick={ClickHandler} to={headerData?.button_three_link || "/project"}>{headerData?.third_button || "Project"}</Link>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <Link onClick={ClickHandler} to={headerData?.button_four_link || "/blog"}>{headerData?.fourth_button || "Blog"}</Link>
                                            </li>
                                            <li>
                                                <Link onClick={ClickHandler} to={headerData?.button_fifth_link || "/broker-registration"}>{headerData?.fifth_button || "Broker Registration"}</Link>
                                            </li>
                                            <li>
                                                <Link onClick={ClickHandler} to={headerData?.button_six_link || "/contact"}>{headerData?.sixth_button || "Contact"}</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-2 col-2">
                                    <div className="header-right">
                                        <div className="header-search-form-wrapper">
                                            <div className="cart-search-contact">
                                                <div className="header-buttons" style={{
                                                    display: 'flex',
                                                    gap: '12px',
                                                    alignItems: 'center'
                                                }}>
                                                    {/* Login Button - Hidden on mobile */}
                                                    <Link
                                                        to={"#"}
                                                        onClick={() => window.location.href = headerData?.login_link || "https://maakdream.com/crm/"}
                                                        className="login-btn d-none d-lg-block"
                                                        style={{
                                                            background: '#336699',
                                                            border: 'none',
                                                            borderRadius: '25px',
                                                            padding: '10px 20px',
                                                            color: 'white',
                                                            fontSize: '14px',
                                                            fontWeight: '600',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            transition: 'all 0.3s ease',
                                                            textDecoration: 'none',
                                                            position: 'relative',
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-2px)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '-6px',
                                                                right: '-12px',
                                                                background: '#ff6b35',
                                                                color: 'white',
                                                                fontSize: '10px',
                                                                fontWeight: 'bold',
                                                                padding: '2px 6px',
                                                                borderRadius: '10px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                zIndex: 1,
                                                                minWidth: '24px',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            CRM
                                                        </div>
                                                        <i className="ti ti-user" style={{ fontSize: '16px' }}></i>
                                                        <span>{headerData?.login_button || "Login"}</span>
                                                    </Link>

                                                    {/* Schedule Meeting Button */}
                                                    <button
                                                        onClick={() => setMeetingSchedulerOpen(true)}
                                                        className="schedule-meeting-btn"
                                                        style={{
                                                            background: '#336699',
                                                            border: 'none',
                                                            borderRadius: '25px',
                                                            padding: '10px 10px',
                                                            color: 'white',
                                                            fontSize: '14px',
                                                            fontWeight: '600',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            transition: 'all 0.3s ease',
                                                            textDecoration: 'none'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = 'translateY(-2px)';
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = 'translateY(0)';
                                                        }}
                                                    >
                                                        <i className="fi ti-calendar" style={{ fontSize: '16px', color: 'white' }}></i>
                                                        <span>{headerData?.meeting_button || "Schedule Meeting"}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>

            {/* Meeting Scheduler Modal */}
            <MeetingScheduler
                isOpen={meetingSchedulerOpen}
                onClose={() => setMeetingSchedulerOpen(false)}
            />
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};
export default connect(mapStateToProps, { removeFromCart })(Header);